import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { TreeView } from "./TreeView";

export const TreeViewPlugin = ()  => {
  const [editor] = useLexicalComposerContext();
  return (<TreeView
      viewClassName="tree-view-output"
      timeTravelPanelClassName="debug-timetravel-panel"
      timeTravelButtonClassName="debug-timetravel-button"
      timeTravelPanelSliderClassName="debug-timetravel-panel-slider"
      timeTravelPanelButtonClassName="debug-timetravel-panel-button"
      editor={editor}
    />
  );
}
